import React, { useEffect, useRef, useState } from 'react';

const BackPricesBox = ({
  runner,
  config,
  value,
  checkMaxOdds,
  validationBM,
  getLock,
  handleOnBackClick,
  checkSuspendedMatchOdds,
  getBoxValue,
}) => {
  const [highlighted, setHighlighted] = useState(['', '', '']);

  const prevPricesRef = useRef([
    { price: null, size: null },
    { price: null, size: null },
    { price: null, size: null },
  ]);
  const firstRender = useRef(true);

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      for (let i = 0; i < 3; i++) {
        prevPricesRef.current[i] = {
          price: runner.backPrices?.[i]?.price,
          size: runner.backPrices?.[i]?.size,
        };
      }
      return;
    }

    const newHighlights = ['', '', ''];
    let changed = false;

    for (let i = 0; i < 3; i++) {
      const current = runner.backPrices?.[i];
      const prev = prevPricesRef.current[i];

      if (current?.price !== prev?.price || current?.size !== prev?.size) {
        if (current?.price > prev?.price) {
          newHighlights[i] = 'higilighted';
        } else if (current?.price < prev?.price) {
          newHighlights[i] = 'higilighted';
        }

        prevPricesRef.current[i] = { price: current?.price, size: current?.size };
        changed = true;

        setTimeout(() => {
          setHighlighted((prev) => {
            const updated = [...prev];
            updated[i] = '';
            return updated;
          });
        }, 500);
      }
    }

    if (changed) {
      setHighlighted(newHighlights);
    }
  }, [runner.backPrices]);

  const renderSpan = (index, className) => {
    const back = runner.backPrices?.[index];
    const disabled = checkMaxOdds(value?.marketId, back?.price ?? 0);

    return (
      <span
        className={`${className} ${disabled ? '' : 'disable'} ${highlighted[index]}`}
        onClick={() => validationBM(back?.price) ?
          handleOnBackClick(
            runner,
            config.back,
            value.marketId,
            back?.price,
            config.isNotfancy,
            value
          ) :''
        }
      >
        {validationBM(back?.price) && !checkSuspendedMatchOdds ? getBoxValue(back) : getLock()}
      </span>
    );
  };

  return (
    <>
      {renderSpan(2, 'blue')}
      {renderSpan(1, 'blue')}
      {renderSpan(0, 'blue')}
    </>
  );
};

export default BackPricesBox;